<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="UserId"
      ref="list"
      unit="领料单"
      :page="page"
      :show-query="true"
      :get-data-func="api.list"
      @row-select="rowSelect"
      v-if="trendShow"
      :show-checkbox="true"
      urlHash="demo/picking"
      :temp-params="tempParams"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
    <!-- 明细 -->
    <el-button
      v-if="show"
      type="primary"
      @click="onCustomTable"
      icon="el-icon-s-tools"
      style="margin: 30px 0 10px 10px"
    >
      明细项
    </el-button>
    <el-table
      ref="multipleTable"
      :row-key="(row) => row.Prop"
      :data="tableData"
      v-if="show"
      stripe
      border
    >
      <template v-for="(item, index) in tableColumns">
        <!-- 需判断是否有价格的权限  -->
        <template v-if="item.IsShow">
          <el-table-column
            :resizable="false"
            :key="`${item.Prop}-${index}`"
            :prop="item.Prop"
            v-if="shouldShowColumn(item)"
            :label="item.Label"
            :align="item.Align ?? 'left'"
            :min-width="item.Width"
            show-overflow-tooltip
          >
            <template slot-scope="{ row }">
              <span v-if="isNumericProperty(item.Prop)">
                {{ $commonJs.toThousands(row[item.Prop]) }}
              </span>
              <span v-else>
                {{ row[item.Prop] }}
              </span>
            </template>
          </el-table-column>
        </template>
      </template>
    </el-table>
    <customTableDialog
      ref="customTableDialog"
      @onSave="onSave"
      :initTableData="tableColumns"
      tableType="生产领料单明细"
    />
    <!-- <el-table  border class="table_bottom table-line tb-c-head" :data="tableData" style="margin-top: 18px;">
      <el-table-column prop="SourceNo" label="加工单号" min-width="100" align="left"></el-table-column>
      <el-table-column prop="ProductNo" label="存货编码" min-width="100" align="left"></el-table-column>
      <el-table-column prop="ProductName" label="存货名称" min-width="100" align="left"></el-table-column>
      <el-table-column prop="ProductSpec" label="规格" min-width="100" align="left"></el-table-column>
      <el-table-column prop="ColorName" label="颜色" min-width="100" align="left"></el-table-column>
      <el-table-column prop="PropertyName" label="属性" min-width="100" align="left"></el-table-column>
      <el-table-column prop="UnitName" label="计量单位" min-width="100" align="left"></el-table-column>
      <el-table-column prop="Quantity" label="数量" min-width="100" align="right">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.Quantity) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Price" label="单价" min-width="100" align="right" v-if="canPrice"></el-table-column>
      <el-table-column prop="Amount" label="金额" min-width="100" align="right" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.Amount) }}</span>
        </template>
      </el-table-column>
    </el-table> -->
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import customTableDialog from "@/components/common/customTableDialog/customTableDialog";

export default {
  mixins: [listMixin],
  components: { list, customTableDialog },
  provide() {
    return {
      IsDefaultMonth: false,
    };
  },
  props: {
    // canPrice: {
    //   typeof: Boolean,
    //   default: true,
    // }
  },
  data() {
    return {
      api: require("@/api/pr/prGetDoc").default,
      sourceTypeApi: require("@/api/ba/sourceType").default,
      FieldSettingApi: require("@/api/sy/fieldSetting").default,
      trendShow: true,
      tableData: [],
      tempParams: {
        GetType: 0,
      },
      tableColumns: [],
      show: false,
    };
  },
  computed: {
    canPrice() {
      return this.$permission.canPrice("/demo/picking");
    },
  },
  created() {
    this.sourceTypeApi.info("生产领料单").then((res) => {
      this.tempParams.GetType = res.SourceTypeId;
    });
    this.getTableColumns();
  },
  methods: {
    /** 价格权限的字段 */
    shouldShowColumn(item) {
      if (!item.IsShow) return false;
      const priceProps = [
        "PurchasePrice",
        "SalePrice",
        "RetailPrice",
        "QuotedPrice",
        "Discount",
        "TaxRate",
        "Price",
        "TaxPrice",
        "Amount",
        "TaxLimit",
        "TaxAmount",
        "DiscountAmount",
        "Rate",
      ];
      return (
        (this.canPrice && priceProps.includes(item.Prop)) ||
        !priceProps.includes(item.Prop)
      );
    },
    /** 千位符格式化数字类型 */
    isNumericProperty(prop) {
      return ["Price", "Amount", "TaxAmount"].includes(prop);
    },
    async getTableColumns() {
      const res = await this.FieldSettingApi.list({ Type: "生产领料单明细" });
      this.tableColumns = [];
      this.tableColumns = res.Data;
    },
    onCustomTable() {
      this.$refs.customTableDialog.dialogVisible = true;
    },
    onSave() {
      this.getTableColumns();
      this.$message.success("保存成功");
    } /** 价格权限的字段 */,
    shouldShowColumn(item) {
      if (!item.IsShow) return false;
      const priceProps = [
        "PurchasePrice",
        "SalePrice",
        "RetailPrice",
        "QuotedPrice",
        "Discount",
        "TaxRate",
        "Price",
        "TaxPrice",
        "Amount",
        "TaxLimit",
        "TaxAmount",
        "DiscountAmount",
        "Rate",
        "Price",
      ];
      return (
        (this.canPrice && priceProps.includes(item.Prop)) ||
        !priceProps.includes(item.Prop)
      );
    },
    /** 千位符格式化数字类型 */
    isNumericProperty(prop) {
      return ["PuQuantity", "Amount", "TaxAmount"].includes(prop);
    },
    async getTableColumns() {
      const res = await this.FieldSettingApi.list({ Type: "生产领料单明细" });
      this.tableColumns = [];
      this.tableColumns = res.Data;
    },
    onCustomTable() {
      this.$refs.customTableDialog.dialogVisible = true;
    },
    onSave() {
      this.getTableColumns();
      this.$message.success("保存成功");
    },
    reviewAll(ids) {
      this.api.reviewAll({ ids }).then((res) => {
        this.$message({
          showClose: true,
          duration: 0,
          dangerouslyUseHTMLString: true,
          message: `<div class="my-message">${res.Msg}</div>`,
          type: res.Code == 0 ? "success" : "warning",
        });
        if (res.Code == 0) this.reload();
      });
    },
    rowSelect(row){
        this.show = true;
        let id = row.DocId;
        this.api.info(id).then(res => {

            this.tableData = res.Data.Products;
        })
    }
  }
};
</script>
